import * as React from 'react';
import { Switch as RNPSwitch } from 'react-native-paper';

type SwitchProps = React.ComponentProps<typeof RNPSwitch>;

export default function Switch(props: SwitchProps) {
  return <RNPSwitch {...props} />;
}
